import { FCC } from "@/types/common";
import { Grid, Stack, styled, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { black } from "@/theme/colors";
import { convertDateFromIsoString } from "@/features/company/utiles/datetime";

type TPartnerTitle = {
  managementNumber?: string | null | undefined;
  title?: string | null | undefined;
  createdAt?: string | null | undefined;
  updatedAt?: string | null | undefined;
};

export const PartnerTitle: FCC<TPartnerTitle> = ({ managementNumber, title, createdAt, updatedAt }) => {
  const { partnerId } = useParams();
  const titleFinal = title ? title : "新規パートナー登録";

  return (
    <TitleContainer>
      <Stack>
        <Stack direction="row" alignContent="center" alignItems="center" gap={1.5} mb={2}>
          <Typography variant="head20Bold">{titleFinal}</Typography>
        </Stack>
        {partnerId && (
          <Grid container gap={2}>
            <Typography variant="body14" color={black[70]}>
              パートナー管理番号：{managementNumber ?? "-"}
            </Typography>
            {createdAt && (
              <Typography variant="body14" color={black[70]}>
                登録日時：{convertDateFromIsoString(createdAt) ?? "-"}
              </Typography>
            )}
            {updatedAt && (
              <Typography variant="body14" color={black[70]}>
                更新日時：{convertDateFromIsoString(updatedAt) ?? "-"}
              </Typography>
            )}
          </Grid>
        )}
      </Stack>
    </TitleContainer>
  );
};

const TitleContainer = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: self-start;
  margin-bottom: 8px;
`;
